import BaseService from "./BaseService";

export default class ExpenseService extends BaseService {
    public static getExpenseTypes(token: string) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'admin/getExpenseTypes', {
            method: 'get',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token

            }
        });
    }

    public static getAllStates(token: string) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'signup/state', {
            method: 'get',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            }
        });
    }

    public static getExpenseDetails(postData: any, token: string) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'admin/getExpenseDetails', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        });
    }

    public static updateExpenseDetails(postData: any, token: string) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'admin/updateExpense', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        });
    }

     public static updateFileReviewStatus(postData: any, token: string) {
        let url = process.env.REACT_APP_API_URL + 'admin/reviewFile';
        // let url = 'http://localhost:3000/admin/reviewFile';
        return BaseService.sendRequest(url, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        });
    }

     public static downloadExpenseProof(postData: any, token: string) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'form433A/downloadExpenseProof', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        });
    }

    public static getUserListPendingForReview (postData: any, token: string) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'admin/getAllUserExpenseProofs', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        });
    }
}